//#region src/pageMetaStore.ts
var e = null, t = /* @__PURE__ */ new Set(), n = {
	set(n) {
		e !== n && (e = n, t.forEach((e) => e()));
	},
	subscribe(e) {
		return t.add(e), () => {
			t.delete(e);
		};
	},
	getSnapshot() {
		return e;
	}
};
//#endregion
export { n as pageMetaStore };
